export const magniteDMTag =
	'<script async src="//micro.rubiconproject.com/prebid/dynamic/7949.js"></script>';

export const magniteLinkTag =
	'<script async src="//link.rubiconproject.com/magnite/7949.js"></script>';
